// https://inventory-api-service-qa.trafficmanager.net/swagger/index.html
// Slowly renaming from "Inventory" to "Shopping"
export const ShoppingApiHost =
    process.env.LOCAL_SHOPPING_API_ENABLED?.toLowerCase() === 'true'
        ? process.env.LOCAL_SHOPPING_API_URL ?? 'http://localhost:5265'
        : `${process.env.AUCTIONS_GATEWAY_BASEURL}inventory`;

export const ShippingApiHost =
    process.env.LOCAL_SHIPPING_API_ENABLED?.toLowerCase() === 'true'
        ? process.env.LOCAL_SHIPPING_API_URL ?? 'http://localhost:5266'
        : `${process.env.AUCTIONS_GATEWAY_BASEURL}/logistics`;
